export function CardSkeleton() {
  return (
    <div className="glass rounded-xl p-5 animate-pulse">
      <div className="flex justify-between mb-4">
        <div className="h-4 w-24 bg-white/10 rounded" />
        <div className="w-14 h-14 bg-white/10 rounded-xl" />
      </div>
      <div className="h-5 w-3/4 bg-white/10 rounded mb-2" />
      <div className="h-4 w-full bg-white/10 rounded mb-1" />
      <div className="h-4 w-2/3 bg-white/10 rounded mb-4" />
      <div className="grid grid-cols-4 gap-2 pt-3 border-t border-white/8">
        {[0, 1, 2, 3].map((i) => <div key={i} className="h-8 bg-white/10 rounded" />)}
      </div>
    </div>
  );
}

export function GridSkeleton({ count = 6 }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {Array.from({ length: count }).map((_, i) => <CardSkeleton key={i} />)}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, subtitle, action }) {
  return (
    <div className="text-center py-20">
      {Icon && <Icon className="w-12 h-12 mx-auto text-slate-600 mb-4" />}
      <h3 className="text-lg font-semibold text-slate-300">{title}</h3>
      {subtitle && <p className="text-sm text-slate-500 mt-1 max-w-md mx-auto">{subtitle}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
